import { render, staticRenderFns } from "./composantLieu.vue?vue&type=template&id=5b5caa34&scoped=true"
import script from "./composantLieu.vue?vue&type=script&lang=js"
export * from "./composantLieu.vue?vue&type=script&lang=js"
import style0 from "./composantLieu.vue?vue&type=style&index=0&id=5b5caa34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5caa34",
  null
  
)

export default component.exports